<style scoped lang="scss">

</style>

<template>
    <div class="uk-width-1-1 uk-grid">
        <header-row></header-row>
        <div class="uk-width-1-1">
            <h2>Household Income</h2>
            <strong>Applicant Income Reported and Verified: {{ totalIncome | formatMoney }}</strong>
            <table class="uk-table uk-table-striped uk-margin-top">
                <thead>
                <tr>
                    <td>Household Member</td>
                    <td>Income Type</td>
                    <td>Annualized Amount</td>
                </tr>
                </thead>
                <tbody v-for="member in application.household.members">
                <tr v-for="row in member.annual_income_meta" v-if="row.amount > 0">
                    <td>{{ member.first_name }} {{ member.last_name }}</td>
                    <td>{{ incomeTypes[row.name] }}</td>
                    <td>{{ getAnnualizedAmount(row.amount, row.interval) | formatMoney }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import HeaderRow from "./HeaderRow";

    export default {
        name: "ApplicantIncome",
        components: {HeaderRow},
        data() {
            return {
                incomeTypes: {
                    'primary_monthly':  'Monthly Gross Wages (Primary Job)',
                    'secondary_monthly':  'Monthly Gross Wages (Second Job)',
                    'tertiary_monthly':  'Monthly Gross Wages (Third Job)',
                    'self_employment_monthly':  'Self Employment',
                    'alimony':  'Gross Alimony Received',
                    'social_security':  'Gross Social Security Received',
                    'unemployment':  'Gross Unemployment Compensation Received',
                    'government_assistance':  'Gross Government Assistance Received',
                    'retirement':  'Gross Retirement Received',
                    'investment':  'Gross Annuity or Investment Received',
                    'rent_roommate':  'Gross Rent from roommate Received',
                    'rent':  'Gross Rental Property Income Received',
                    'contributions':  'Gross Contributions from Family or Friends Received',
                    'other':  'Gross Other Monthly Income Received',
                }
            }
        },
        computed: {
            totalIncome() {
                let value = 0;
                _.each(this.application.household.members, member => value += member.annual_income);
                return value;
            },
            ...mapState('Application', {
                assets: 'assets',
                application: 'application',
                applicant: 'applicant',
                hhMembers: 'hhMembers',
                documentRequests: 'documentRequests',
                documents: 'documents',
                renterManager: 'renterManager',
                landlordConfirmations: 'landlordConfirmations',
            }),
            ...mapGetters('Application', {
                headOfHousehold: 'headOfHousehold'
            })
        },
        methods: {
            getAnnualizedAmount(value, interval) {
                let amount;
                switch(interval) {

                    case 'monthly':
                    case 'other':
                        amount = value * 12;
                        break;

                    case 'weekly':
                        amount = value * 52;
                        break;

                    case 'biweekly':
                        amount = value * 26;
                        break;

                    case 'bimonthly':
                        amount = value * 24;
                        break;

                    case 'annually':
                        amount = value;
                        break;

                    default: amount = value * 12;
                }
                return amount;
            }
        }
    }
</script>
